import { Box, Grid, Typography } from "@material-ui/core";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";
import { getAllFileCompressionConfigs } from "src/app-redux/configuration/actions/configurationActions";
import { useAppDispatch, useAppSelector } from "src/app-redux/hooks";
import {
  getWeightScanExistingDocuments,
  uploadVehicleScanDocs,
} from "src/app-redux/vehicle/actions/vehicleActions";
import Backdrop from "@material-ui/core/Backdrop";
import {
  currentSelectedVehicleRegNo,
  currentSelectedVehicleScanId,
  loader as vehicleLoader,
} from "src/app-redux/vehicle/vehicleSlice";
import CommonButton from "src/components/CommonButton/CommonButton";
import { useStyles } from "./style";
import Close from "@material-ui/icons/Close";
import IconButton from "@mui/material/IconButton";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import { downloadFile } from "src/app-redux/common-actions";
import CommonDialog from "src/components/AlertDialog/CommonDialog";
import CommonLoader from "src/components/Loader/CommonLoader";

export interface IDrawerFilesProps {
  refreshDrawer: number;
}

export default function DrawerFiles(props: IDrawerFilesProps) {
  const classes = useStyles();
  const dispatch = useAppDispatch();
  const selectedVehicleScanId: any = useAppSelector(currentSelectedVehicleScanId);
  const selectedVehicleRegNo: any = useAppSelector(currentSelectedVehicleRegNo);

  const [fileToUpload, setFileToUpload] = React.useState<any[]>([]);
  const [validFileTypes, setValidFileTypes] = React.useState<any>([]);
  const [validFileSize, setValidFileSize] = React.useState(0);
  const [isValidFileType, setIsValidFileType] = React.useState<boolean[]>([]);
  const [isValidFileSize, setIsValidFileSize] = React.useState<boolean[]>([]);
  const loader2: any = useAppSelector(vehicleLoader);

  let fileTypesArr: any[] = [];
  let maxFileSize = 0;
  const [existingFiles, setexistingFiles] = React.useState<any[]>([]);

  const onDrop = React.useCallback((acceptedFiles: File[]) => {
    const size: boolean[] = [];
    const type: boolean[] = [];

    acceptedFiles.forEach((file: any) => {
      const split = file.name.split(".");
      type.push(fileTypesArr.includes(`.${split[split.length - 1]}`.toLowerCase()));
      size.push(file.size / (1024 * 1024) <= maxFileSize);
    });

    setIsValidFileSize(size);
    setIsValidFileType(type);
    setFileToUpload(acceptedFiles);
  }, []);
  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  useEffect(() => {
    getExistingDocs();
    getFileConfig();
  }, []);

  useEffect(() => {
    getExistingDocs();
  }, [props.refreshDrawer]);

  const getExistingDocs = async () => {
    const res: any = await dispatch(
      getWeightScanExistingDocuments({
        id: selectedVehicleScanId,
        isScan: true,
        isNodWeightFile: false,
      })
    );
    if (res?.payload?.length) {
      setexistingFiles(res?.payload);
    }
  };

  const getFileConfig = async () => {
    const res: any = await dispatch(getAllFileCompressionConfigs());
    if (res.payload && res.payload[0]) {
      setValidFileTypes(res.payload[0].fileTypes.split(","));
      setValidFileSize(res.payload[0].fileSizeThreshold);
      fileTypesArr = res.payload[0].fileTypes.split(",");
      maxFileSize = res.payload[0].fileSizeThreshold;
    }
  };

  const formik = useFormik<any>({
    enableReinitialize: true,
    initialValues: {
      vehicleScanId: selectedVehicleScanId,
      registerationNumber: selectedVehicleRegNo,
    },
    onSubmit: async (values: any, actions) => {
      const form = new FormData();
      form.append("vehicleScanId", values.vehicleScanId);
      form.append("registerationNumber", values.registerationNumber);
      fileToUpload.length
        ? fileToUpload.forEach((file) => {
            form.append("files", file);
          })
        : form.append("files", "");

      const res: any = await dispatch(uploadVehicleScanDocs(form));
      if (res.payload) {
        actions.setSubmitting(false);
        formik.resetForm();
        formik.setValues(formik.initialValues);
        setFileToUpload([]);
        setIsValidFileType([]);
        setIsValidFileSize([]);
        getExistingDocs();
        return;
      }
    },
  });

  const removeFileFromIndex = (index: number) => {
    const upload = fileToUpload;
    upload.splice(index, 1);
    setFileToUpload(upload);

    const size: boolean[] = [];
    const type: boolean[] = [];

    fileToUpload.forEach((file: any) => {
      const split = file.name.split(".");
      type.push(validFileTypes.includes(`.${split[split.length - 1]}`));
      size.push(file.size / (1024 * 1024) <= validFileSize);
    });

    setIsValidFileSize(size);
    setIsValidFileType(type);
  };

  const downloadDocument = async (item: any) => {
    const fileMetaData = {
      url: `${process.env.REACT_APP_API_URL}/get-gate-doc-by-id/${item.id}?docType=2`,
      contentType: ".jpg",
      fileName: item.title,
    };
    dispatch(downloadFile(fileMetaData));
  };

  const [isOpenDailog, setIsOpenDailog] = useState(false);
  const [thumbnailDetails, setThumbnailDetails] = useState<any>({});
  const toggleDialog = async (item: any) => {
    setThumbnailDetails(item);
    setIsOpenDailog(!isOpenDailog);
  };
  return (
    <>
      <Backdrop className={classes.backdrop} open={loader2}>
        <CommonLoader />
      </Backdrop>
      <div className={classes.drawerDetails}>
        {/* Drawer Status Item  */}

        <Grid container spacing={2} className="topContainer" style={{ marginTop: "5px" }}>
          <Grid container direction="row" className="itemRow" spacing={2}>
            {/* File Upload */}
            <Grid item xs={12} md={12}>
              <Box
                {...getRootProps()}
                p={0}
                pl={1}
                border={"1px solid #72CA00"}
                borderRadius={5}
                height={38}
                pb={4}
                overflow={"auto"}
                display={"flex"}
                flexWrap={"wrap"}
                borderColor={isDragActive ? "error.main" : "secondary.main"}
              >
                <input {...getInputProps()} />

                {fileToUpload.length ? (
                  fileToUpload.map((file, index) => {
                    return (
                      <div
                        key={file.name}
                        style={{
                          marginTop: "6px",
                          backgroundColor: "#E67817",
                          padding: "3px 15px 3px 5px",
                          borderRadius: "10px",
                          maxWidth: "122px",
                          display: "flex",
                          flexWrap: "wrap",
                          marginLeft: "5px",
                        }}
                      >
                        <div
                          style={{
                            maxWidth: "100px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            fontSize: "11px",
                            color: "white",
                          }}
                        >
                          {file.name}
                        </div>
                        <IconButton
                          aria-label="Search"
                          onClick={(event) => {
                            event.stopPropagation();
                            removeFileFromIndex(index);
                          }}
                          edge="end"
                          className="icon-button-search"
                          style={{
                            color: "white",
                            padding: 0,
                            marginTop: "2px",
                            width: "10px",
                            height: "10px",
                            overflow: "hidden",
                            marginRight: "2px !important",
                          }}
                        >
                          <Close />
                        </IconButton>
                      </div>
                    );
                  })
                ) : isDragActive ? (
                  <p>Drop a file here ...</p>
                ) : (
                  <p style={{ color: "rgb(181 178 178)", marginTop: 9, paddingBottom: 10 }}>
                    {/* Drag and drop file here,or click to select a file */}
                    Upload File
                  </p>
                )}
              </Box>
              <Box>
                <p style={{ color: "#f44336", marginBottom: 0 }}>
                  <ul
                    style={{
                      paddingLeft: "16px",
                      margin: 0,
                      display: isValidFileType.includes(false) ? "block" : "none",
                    }}
                  >
                    <li>
                      Only{" "}
                      {validFileTypes.map((type: any, index: number) => {
                        return index < validFileTypes.length - 1 ? `${type},` : type;
                      })}{" "}
                      files are allowed.
                    </li>
                  </ul>
                  <ul
                    style={{
                      paddingLeft: "16px",
                      margin: 0,
                      display: isValidFileSize.includes(false) ? "block" : "none",
                    }}
                  >
                    <li>File size cannot exceed {validFileSize}MB.</li>
                  </ul>
                </p>
              </Box>
            </Grid>

            <Grid container item xs={12} md={12}>
              <Grid item xs={12} md={9}>
                <Box textAlign="left" mt={1}>
                  <CommonButton
                    cssClass="customSubmitBtn"
                    onClick={() => {
                      formik.resetForm();
                      formik.setValues(formik.initialValues);
                      setFileToUpload([]);
                      setIsValidFileType([]);
                      setIsValidFileSize([]);
                    }}
                  >
                    Reset
                  </CommonButton>
                  <CommonButton
                    cssClass="customSubmitBtn"
                    isGreen
                    disable={!isValidFileType || !isValidFileSize || !fileToUpload.length}
                    onClick={() => {
                      formik.submitForm();
                    }}
                  >
                    Save
                  </CommonButton>
                </Box>
              </Grid>
            </Grid>
          </Grid>
          <Grid container direction="row" className="itemRow" spacing={2}>
            <Grid
              item
              md={12}
              id="main-div"
              className={classes.drawerDetails}
              style={{
                height: "max-content",
              }}
            >
              <Grid container direction="column">
                {/* History Item  */}
                {existingFiles.length !== 0 ? (
                  existingFiles.map((item: any) => (
                    <Grid md={6} key={item.id} style={{ padding: "5px" }}>
                      <Grid md={12}>
                        <Box style={{ cursor: "pointer" }} onClick={() => toggleDialog(item)}>
                          <img
                            width="400px"
                            height="200px"
                            src={`data:image/${item?.extension};base64,${item?.base64Image}`}
                            alt={item.extension}
                          />
                        </Box>
                        <Box display="flex">
                          <Grid md={3} style={{ marginTop: "8px" }}>
                            <Typography className="subHeading itemName">
                              {item.originalFileName}
                            </Typography>
                          </Grid>
                          <Grid md={2}>
                            <IconButton
                              onClick={() => {
                                downloadDocument(item);
                              }}
                            >
                              <CloudDownloadIcon />
                            </IconButton>
                          </Grid>
                        </Box>
                        <Box style={{ width: "400px", textAlign: "justify" }}>
                          <Typography className="">
                            <b>Disclaimer:</b> This is a system generated image of the scanned
                            container/vehicle. National Logistics Corporation (NLC) or its staff
                            does not bear any liability of any nature whatsoever, regarding analysis
                            or the contents of this image. NLC is neither responsible nor liable, to
                            analyze/examine/compare/use the content of this scanned image for any
                            purpose even upon request. Scanning is a Non-Intrusive Inspection (NII)
                            and NLC only provides equipment/technical support to carry out the same
                            to Custom or any other Law enforcement agency desirous of doing so. It
                            is the sole responsibility of the requesting party for this (NII) to
                            use/compare/analyze this image to decide the fate of this
                            container/vehicle. NLC is not responsible in any case or under any
                            circumstances, either for the selection of this container/vehicle for
                            (NII) or its hold or release on the basis of the (NII).
                          </Typography>
                        </Box>
                      </Grid>
                    </Grid>
                  ))
                ) : (
                  <div></div>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
      <CommonDialog
        isOpen={isOpenDailog}
        handleClose={toggleDialog}
        maxWidth="md"
        heading={"Scanner File Preview"}
      >
        <Box>
          <Box style={{ textAlign: "center" }}>
            <img
              style={{ width: "450px", height: "300px" }}
              src={`data:image/${thumbnailDetails?.extension};base64,${thumbnailDetails?.base64Image}`}
              alt={thumbnailDetails?.extension}
            />
          </Box>
          <Box display="flex">
            <Box mt={1}>
              <Typography className="subHeading itemName">
                {thumbnailDetails?.originalFileName}
              </Typography>
            </Box>
            <Box>
              <IconButton
                onClick={() => {
                  downloadDocument(thumbnailDetails);
                }}
              >
                <CloudDownloadIcon />
              </IconButton>
            </Box>
          </Box>
          <Box style={{ textAlign: "justify" }}>
            <Typography style={{ width: "450px" }}>
              <b>Disclaimer:</b> This is a system generated image of the scanned container/vehicle.
              National Logistics Corporation (NLC) or its staff does not bear any liability of any
              nature whatsoever, regarding analysis or the contents of this image. NLC is neither
              responsible nor liable, to analyze/examine/compare/use the content of this scanned
              image for any purpose even upon request. Scanning is a Non-Intrusive Inspection (NII)
              and NLC only provides equipment/technical support to carry out the same to Custom or
              any other Law enforcement agency desirous of doing so. It is the sole responsibility
              of the requesting party for this (NII) to use/compare/analyze this image to decide the
              fate of this container/vehicle. NLC is not responsible in any case or under any
              circumstances, either for the selection of this container/vehicle for (NII) or its
              hold or release on the basis of the (NII).
            </Typography>
          </Box>{" "}
        </Box>
      </CommonDialog>
    </>
  );
}
